var listeners = {};

var NativeAppEventEmitter = {
  addListener : function(eventType, listener, context)
  {
    if( !listeners[eventType] ) listeners[eventType] = [];
    var entry = { listener: listener, context: context };
    listeners[eventType].push(entry);

    return {
      remove : function()
      {
        var arr = listeners[eventType];
        if( !arr ) return;
        var index = arr.indexOf(entry);
        if( index > -1 ) arr.splice(index, 1);
      }
    };
  },

  removeAllListeners : function(eventType)
  {
    if( typeof eventType === 'undefined' ) listeners = {};
    else delete listeners[eventType];
  },

  removeListener : function(eventType, listener)
  {
    var arr = listeners[eventType];
    if( !arr ) return;
    listeners[eventType] = arr.filter(function(entry) { return entry.listener !== listener; });
  },

  listenerCount : function(eventType)
  {
    return listeners[eventType] ? listeners[eventType].length : 0;
  },

  emit : function(eventType)
  {
    var arr = listeners[eventType];
    if( !arr ) return;
    var args = Array.prototype.slice.call(arguments, 1);
    arr.slice().forEach(function(entry) { entry.listener.apply(entry.context, args); });
  }
};

module.exports = NativeAppEventEmitter;
